jQuery( function( $ ){
	$( '#account-update' ).dirrty( {
		preventLeaving: false

		// this function is called when the form.trigger's "dirty"
	} ).on( 'dirty', function() {
		$( this ).find( 'button' ).prop( 'disabled', false );

		// this function is called when the form.trigger's "clean"
	} ).on( 'clean', function() {
		$( this ).find( 'button' ).prop( 'disabled', true );
	} );

	$( '#password-update' ).dirrty( {
		preventLeaving: false

		// this function is called when the form.trigger's "dirty"
	} ).on( 'dirty', function() {
		$( this ).find( 'button' ).prop( 'disabled', false );

		// this function is called when the form.trigger's "clean"
	} ).on( 'clean', function() {
		$( this ).find( 'button' ).prop( 'disabled', true );
	} );

} );
